import { axiosClient } from "$/http"

import {
    EParticipantOnboardingStep as EStep,
    EParticipantOnboardingMutationUrl as EUrl
} from "./participant.onboarding.api.config"
import {
    type TParticipantOnboardingCoachStepPairingMutationPayload as TCoachStepPairingPayload,
    type TParticipantOnboardingMutationResponse as TMutationResponse,
    type TParticipantOnboardingMutationPayloadMap as TPayloadMap
} from "./participant.onboarding.api.types"

const stepNextStepUrlMap: { [S in EStep]?: () => string } = {
    [EStep.Profile]: EUrl.Profile.NextStep,
    [EStep.Video]: EUrl.Video.NextStep,
    [EStep._LegacyModules]: EUrl._LegacyModules.NextStep,
    [EStep.Diagnostic]: EUrl.Diagnostic.NextStep,
    [EStep._LegacyDiagnosticResponses]: EUrl._LegacyDiagnosticResponses.NextStep,
    [EStep.Reflection]: EUrl.Reflection.NextStep,
    [EStep.Holds]: EUrl.Holds.NextStep,
    [EStep.Coach]: EUrl.Coach.NextStep
}

function createNextStepMutator<TStep extends EStep>(
    step: TStep
): (data: TPayloadMap[TStep]) => Promise<TMutationResponse> {
    return async function participantOnboardingApiMutator<TStep extends EStep>(
        data: TPayloadMap[TStep]
    ): Promise<TMutationResponse> {
        return axiosClient.post(stepNextStepUrlMap[step](), data)
    }
}

async function coachStepPairingMutator(data: TCoachStepPairingPayload[]): Promise<TMutationResponse> {
    return axiosClient.post(EUrl.Coach.Pairing(), data)
}

export default {
    nextStep: createNextStepMutator,
    coachStepPairing: coachStepPairingMutator
}
